<script setup>
import { reactive, computed } from 'vue'
import Cognito  from '../utils/cognito.js'

const props = defineProps({
  email: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['completed', 'back'])

const resetState = reactive({
  code: '',
  newPassword: '',
  confirmPassword: '',
  isSubmitting: false,
})

const isDisabled = computed(() => {
  return (
    !resetState.code ||
    !resetState.newPassword ||
    !resetState.confirmPassword ||
    resetState.isSubmitting
  )
})

const submitPassword = async() => {
  if (resetState.newPassword !== resetState.confirmPassword) {
    alert('新しいパスワードが一致しません。')
    return
  }
  if (resetState.newPassword.length < 8) {
    alert('パスワードは8文字以上で入力してください。')
    return
  }
  // バリデーション関数
  const isValidPassword = (password) => {
    return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).+$/.test(password)
  }
  // 内容チェック
  if (!isValidPassword(resetState.newPassword)) {
    alert("パスワードは英字・数字・記号をそれぞれ1文字以上含めてください")
    return
  }
  resetState.isSubmitting = true

  // パスワードを再設定
  try{
    await Cognito.resetCognitoPass(props.email, resetState.code, resetState.newPassword);
    // パスワード再設定完了
    resetState.isSubmitting = false
    emit('completed')
  } catch (err) {
    alert('パスワードの再設定に失敗しました。')
    resetState.isSubmitting = false
  }
}
</script>

<template>
    <div class="userPassword">
      <div class="titleArea">
        <p class="title">認証コードと新しいパスワード入力</p>
      </div>

      <table class="commonTable">
        <tbody>
          <tr>
            <th></th>
          </tr>
          <tr>
            <td class="firstTd notButtom">認証コード</td>
          </tr>
          <tr>
            <td class="firstTd notTop">
              <input
                type="text"
                v-model="resetState.code"
                class="inputText"
                placeholder="no-reply@verificationemail.comから届いた認証コードを入力"
              />
            </td>
          </tr>
          <tr>
            <td class="firstTd notButtom">新しいパスワード</td>
          </tr>
          <tr>
            <td class="firstTd notTop">
              <input
                type="password"
                v-model="resetState.newPassword"
                class="inputText"
                placeholder="新しいパスワードを入力"
              />
            </td>
          </tr>
          <tr>
            <td class="firstTd notButtom">新しいパスワード（確認）</td>
          </tr>
          <tr>
            <td class="firstTd notTop">
              <input
                type="password"
                v-model="resetState.confirmPassword"
                class="inputText"
                placeholder="新しいパスワードを再入力"
              />
            </td>
          </tr>
          <tr>
            <td class="updateArea">
              <button
                type="button"
                class="nextButton"
                :class="{ disabled: isDisabled }"
                id="passResetButton"
                :disabled="isDisabled"
                @click="submitPassword"
              >
                {{ resetState.isSubmitting ? '設定中...' : '設定する' }}
              </button>
              <div class="returnpassreset">
                <button type="button" class="clearButton" @click="emit('back')">
                  再度メールを送信する
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<style scoped>
.userPassword {
  padding: 0 20% 0 20%;
  background-color: #e7e6e6;
}
.titleArea .title {
  text-align: center;
  font-size: 40px;
  padding: 20px 0 0;
}
.inputText{
    padding: 5px 10px;
    border: 1px solid #969292;
    border-radius: 5px;
    background-color: white;
    text-align: left;
    width:90%;
}
.updateArea {
  padding: 20px 0;
  text-align: center;
}
.errorMessage p {
  color: red;
  margin: 0;
}
.returnpassreset{
    margin:15px 0;
}
.nextButton, .clearButton {
  width: 100%;
  max-width: 300px;
  box-sizing: border-box;
}
@media (max-width: 768px) {
  .titleArea .title {
    font-size: 22px;
  }     
}
</style>